module.exports = __webpack_public_path__ + "img/hand-holding-dollar.c30553a3.svg";